import React from "react"
import { Form } from "antd"
import type { FormItemProps } from "antd/lib/form"

export const FormItem = ({ children, ...props }: FormItemProps): JSX.Element => {
  return <Form.Item {...props}>{children}</Form.Item>
}
